import {
    addQueryAPI,
    addReminderAPI,
    deleteReminderAPI,
    deleteQueryAPI,
    getQueriesAPI,
    getReminderAPI,
    updateQueryAPI
} from '../adapter/adapter'

export function getQueryHelper() {
    let promise = new Promise(function (resolve, reject) {
        getQueriesAPI()
            .then(res => {
                console.log(res.data)

                if (res?.data?.error) {
                    reject(res.data.error.message)
                } else if (res?.data?.data && res?.data?.data) {
                    resolve(res.data.data)
                } else {
                    reject('get query Failure')
                }
            })
            .catch(err => {
                reject('get query Failure')
            })
    })

    return promise
}

export function addQueryHelper(reqData) {
    let promise = new Promise(function (resolve, reject) {
        addQueryAPI(reqData)
            .then(res => {
                console.log(res.data)

                if (res?.data?.error) {
                    reject(res.data.error.message)
                } else if (res?.data?.data && res?.data?.data) {
                    resolve(res.data.data)
                } else {
                    reject('add query Failure')
                }
            })
            .catch(err => {
                reject('add query Failure')
            })
    })

    return promise
}

export function updateQueryHelper(reqData) {
    let promise = new Promise(function (resolve, reject) {
        updateQueryAPI(reqData)
            .then(res => {
                console.log(res.data)

                if (res?.data?.error) {
                    reject(res.data.error.message)
                } else if (res?.data?.data && res?.data?.data) {
                    resolve(res.data.data)
                } else {
                    reject('update query Failure')
                }
            })
            .catch(err => {
                reject('update query Failure')
            })
    })

    return promise
}

export function deleteQueryHelper(id) {
    let reqData = {
        id: id
    }

    let promise = new Promise(function (resolve, reject) {
        deleteQueryAPI(reqData)
            .then(res => {
                console.log(res.data)

                if (res?.data?.error) {
                    reject(res.data.error.message)
                } else if (res?.data?.data) {
                    resolve(res.data.data)
                } else {
                    reject('delete query Failure')
                }
            })
            .catch(err => {
                reject('delete query Failure')
            })
    })

    return promise
}

export function getReminderHelper() {
    let promise = new Promise(function (resolve, reject) {
        getReminderAPI()
            .then(res => {
                console.log(res.data)

                if (res?.data?.error) {
                    reject(res.data.error.message)
                } else if (res?.data?.data && res?.data?.data) {
                    resolve(res.data.data)
                } else {
                    reject('get reminder Failure')
                }
            })
            .catch(err => {
                reject('get reminder Failure')
            })
    })

    return promise
}

export function addReminderHelper(reqData) {
    let promise = new Promise(function (resolve, reject) {
        addReminderAPI(reqData)
            .then(res => {
                console.log(res.data)

                if (res?.data?.error) {
                    reject(res.data.error.message)
                } else if (
                    res?.data?.data &&
                    res?.data?.data?.is_reminder_added
                ) {
                    resolve(res.data.data?.is_reminder_added)
                } else {
                    reject('add reminder Failure')
                }
            })
            .catch(err => {
                reject('add reminder Failure')
            })
    })

    return promise
}

export function deleteReminderHelper(id) {
    let reqData = {
        id: id
    }

    let promise = new Promise(function (resolve, reject) {
        deleteReminderAPI(reqData)
            .then(res => {
                console.log(res.data)

                if (res?.data?.error) {
                    reject(res.data.error.message)
                } else if (
                    res?.data?.data &&
                    res?.data?.data?.is_reminder_deleted
                ) {
                    resolve(res.data.data?.is_reminder_deleted)
                } else {
                    reject('delete reminder Failure')
                }
            })
            .catch(err => {
                reject('delete reminder Failure')
            })
    })

    return promise
}

